import AnxietyDisorderTest from '../components/assessment/anxietyDisorderTest';
import './SelfTest.css'

const AnxietyTestPage =()=>{
    return (
        <>
        <div className="DP">
       <AnxietyDisorderTest/>
        </div>
        </>
    )
}

export default AnxietyTestPage;